import { ApplicationQueueGrid } from './pages/ApplicationQueueGrid'
import { ApplicationQueueList } from './pages/ApplicationQueueList'
import withAuth from '../../hooks/withAuthorization'
import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import { ApplicationQueuePerformanceDashboard } from './pages/ApplitionQueuePerformanceDashboard'

const ApplicationQueueGridWithAuth = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  ApplicationQueueGrid
)
const ApplicationQueueListWithAuth = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  ApplicationQueueList
)
const ApplicationQueuePerformanceDashboardWithAuth = withAuth([
  ROLE_PLATFORM_HIXME_ADMIN,
])(ApplicationQueuePerformanceDashboard)

const ApplicationQueueRoutes = [
  {
    path: '/application-queue',
    component: ApplicationQueueGridWithAuth,
  },
  {
    path: '/application-queue/performance-dashboard',
    component: ApplicationQueuePerformanceDashboardWithAuth,
  },
  {
    path: '/application-queue/:assignee',
    component: ApplicationQueueListWithAuth,
  },
]

export default ApplicationQueueRoutes
